import { UseMutateFunction } from "@tanstack/react-query";
import { AxiosError } from "axios";
import * as yup from "yup";
import { StaffListResponse } from "../Staff/Staff.constants";
import { DeviceBuySellResponse } from "../Stock/Stock.constants";

export type Supplier = {
  id: string;
  name: string;
  description: string;
  phone_number?: string;
};

export interface SupplierListResponse extends Array<Supplier> {}

export interface SupplierModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: any;
  mutate: UseMutateFunction<
    SupplierListResponse,
    AxiosError<any>,
    any,
    unknown
  >;
}

export interface SupplierDetailModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: any;
}

export interface SupplierAddRequest {
  email: string;
  password?: yup.Maybe<string | undefined>;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
}

export interface SupplierAddResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

export interface SupplierUpdateRequest {
  id: string;
  email: string;
  password?: yup.Maybe<string | undefined>;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
}

export interface SupplierUpdateResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

export interface SupplierDeleteRequest {
  id: string;
}

export interface SupplierDeleteResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

export interface SupplierPaymentRequest {
  id: string;
}

interface DevicePart {
  id: number;
  name: string;
  description: string;
  warranty_period: number;
  total_payment: number;
  total_paid: number;
  remaining: number;
}

interface Device {
  id: number;
  name: string;
  description: string;
  warranty_period: number;
  system: string;
  device_parts: DevicePart[];
  total_payment: number;
  total_paid: number;
  remaining: number;
}

export interface SupplierPaymentResponse {
  devices: Device[];
  device_parts: DevicePart[];
  status: number;
}

export interface SupplierPaymentModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalData?: {
    data?: {
      id: number;
      name: string;
      description: string;
      warranty_period: number;
      system: string;
      device_parts: Array<string>;
      total_payment: number;
      total_paid: number;
      remaining: number;
    };
    modalType?: string | undefined;
  };
  buySellListMutate: UseMutateFunction<
    SupplierPaymentResponse,
    AxiosError<any>,
    SupplierPaymentRequest,
    unknown
  >;
}

export const supplierAddSchema = yup.object().shape({
  name: yup.string().required("Ad boş bırakılamaz"),
  description: yup.string().required("Açıklama boş bırakılamaz"),
  phone_number: yup
    .string()
    .notRequired()
    .matches(/^0[0-9]{10}$/, "Geçerli bir telefon numarası girin"),
});

export const supplierUpdateSchema = yup.object().shape({
  name: yup.string().required("Ad boş bırakılamaz"),
  description: yup.string().required("Açıklama boş bırakılamaz"),
  phone_number: yup
    .string()
    .notRequired()
    .matches(/^0[0-9]{10}$/, "Geçerli bir telefon numarası girin"),
});

export const supplierBuySellSchema = yup.object().shape({
  total_price: yup.string().required("Toplam fiyat boş bırakılamaz"),
});
